import { type FC } from "preact/compat";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { useEffect } from "preact/hooks";
import "swiper/css";
import "./index.scss";
import Icons from "@components/icons";

interface SlideType {
  imageObject?: {
    src: string;
    alt: string;
    width: number;
  };
  quote: string;
  attributed: string;
}

interface SwiperCarouselProps {
  id: string;
  slides: SlideType[];
}

export const SwiperCarousel: FC<SwiperCarouselProps> = ({ id, slides }) => {
  useEffect(() => {
    const swiper = new Swiper(".quote-carousel-display", {
      freeMode: true,
      loop: true,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      slidesPerView: "auto",
      spaceBetween: 15,
      breakpoints: {
        1024: {
          spaceBetween: 17,
        },
      },
      modules: [Navigation],
      navigation: {
        nextEl: ".quote-carousel-display__navigation-button--next",
        prevEl: ".quote-carousel-display__navigation-button--prev",
      },
    });

    return () => swiper.destroy();
  }, []);

  return (
    <div className="quote-carousel-display swiper">
      <div id={id} className="quote-carousel-display__container swiper-wrapper">
        {slides.map((slide, index) => (
          <div key={index} className="quote-carousel-display__slide swiper-slide">
            <blockquote className="quote-carousel-display__slide-quote">
              <p className="quote-carousel-display__slide-quote-text text-2xl md:text-[2rem]">
                {slide.quote}
              </p>
            </blockquote>
            {slide.imageObject && (
              <div className="quote-carousel-display__slide-image-container">
                <img
                  className="quote-carousel-display__slide-image"
                  src={slide.imageObject.src}
                  alt={slide.imageObject.alt}
                  width={slide.imageObject.width}
                />
                <cite className="quote-carousel-display__slide-quote-attributed">
                  {slide.attributed}
                </cite>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="quote-carousel-display__navigation">
        <div className="quote-carousel-display__navigation-button quote-carousel-display__navigation-button--prev swiper-button-prev">
          <Icons.IconLeft />
        </div>
        <div className="quote-carousel-display__navigation-button quote-carousel-display__navigation-button--next swiper-button-next">
          <Icons.IconRight />
        </div>
      </div>
    </div>
  );
};
